import PropTypes from 'prop-types';

export const propTypes = {
  categoryName: PropTypes.string.isRequired,
  abbrBrand: PropTypes.string.isRequired,
  criticalCss: PropTypes.array.isRequired,
};
